export default "/public/dist/resources/AVVISOODC14FEBBRAIO2023.pdf";